// Libs
import React from "react";

// Style
import { StyledSubcategory } from "./SubcategoryStyle";

const Subcategory = ({ children, onClick, checked }) => {
  return (
    <StyledSubcategory checked={checked} onClick={() => onClick()}>
      {children}
    </StyledSubcategory>
  );
};

export default Subcategory;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/subcategories/Subcategory.js